import _ from 'underscore';
import React, { useCallback, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import {
  CampaignPoliticalAdsDeclaration, CampaignPoliticalAdsDialog, logPoliticalAdsFlowClickedContinue,
} from '@bingads-webui-campaign-react/political-ads-declaration';

export function PoliticalAdsDeclaration(props) {
  const {
    bizInfoData,
    updateBizInfoData,
    activity,
    isSaving,
    showError,
  } = props;

  const {
    isPoliticalAdsConfirmed = false,
  } = bizInfoData || {};

  const politicalAdsDeclarationDialogRef = useRef(null);

  const onChangePoliticalAdsDeclaration = useCallback((checked) => {
    updateBizInfoData({
      isPoliticalAdsConfirmed: checked,
    });
  }, [updateBizInfoData]);

  const logPoliticalAdsOnClickContinue = useCallback(() => {
    logPoliticalAdsFlowClickedContinue(activity.trace, 'campaign-creation', isPoliticalAdsConfirmed);
  }, [activity, isPoliticalAdsConfirmed]);

  const openPoliticalAdsDeclarationDialog = useCallback(() => {
    if (politicalAdsDeclarationDialogRef.current) {
      politicalAdsDeclarationDialogRef.current.open(document.activeElement);
    }
  }, []);

  useEffect(() => {
    if (isSaving && showError && !isPoliticalAdsConfirmed) {
      openPoliticalAdsDeclarationDialog();
    }
  }, [isPoliticalAdsConfirmed, openPoliticalAdsDeclarationDialog, isSaving, showError]);

  useEffect(() => {
    if (isSaving) {
      logPoliticalAdsOnClickContinue();
    }
  }, [isSaving, logPoliticalAdsOnClickContinue]);

  return (
    <div className="political-ads-declaration-container">
      <CampaignPoliticalAdsDeclaration
        onChange={onChangePoliticalAdsDeclaration}
        logger={activity}
        actionButtonText={_TL_('Next')}
      />
      <CampaignPoliticalAdsDialog ref={politicalAdsDeclarationDialogRef} />
    </div>
  );
}

// @aiContributed-MAPFuse-2026-01-29
PoliticalAdsDeclaration.propTypes = {
  classes: PropTypes.shape({
    politicalAdsDeclarationContainer: PropTypes.string,
  }),
  bizInfoData: PropTypes.shape({
    isPoliticalAdsConfirmed: PropTypes.bool,
  }),
  updateBizInfoData: PropTypes.func,
  activity: PropTypes.shape({
    trace: PropTypes.func,
    error: PropTypes.func,
  }),
  isSaving: PropTypes.bool,
  showError: PropTypes.bool,
};

PoliticalAdsDeclaration.defaultProps = {
  classes: {},
  bizInfoData: {},
  updateBizInfoData: _.noop,
  activity: {
    trace: _.noop,
    error: _.noop,
  },
  isSaving: false,
  showError: false,
};
